import request from './request'

// 积分相关接口

// 获取积分规则
export function getRule() {
  const url = '/platform_score/scorerule'
  return request.get(url)
}

// 我的积分
export function getInfo(phone, page = 0) {
  const url = '/platform_score/scoredetail'
  return request.get(url, {
    params: {
      phone,
      page
    }
  })
}



// WEBPACK FOOTER //
// ./src/api/integral.js